<input
  type="hidden"
  [name]="key"
  [id]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
/>
